import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { useReadLocalStorage } from "usehooks-ts";
import MessageBar from "~/components/MessageBar";
import SearchPanel from "~/features/Search/SearchPanel";
import SearchResult from "~/features/Search/SearchResult";

const MainSearchPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = useReadLocalStorage("_t");

    useEffect(() => {
        if (!token) {
            navigate("/auth/login");
        }
    }, [token, navigate]);

    return (
        <div className="flex h-full w-auto justify-center transition-all">
            {location.search !== "" ? <SearchResult /> : <SearchPanel />}
            <MessageBar />
            <Toaster />
        </div>
    );
};

export default MainSearchPage;
